import BaseApi from '@/api/base';
import { getImpersonationParams } from '@/util';
import axios from 'axios';

const setMessagesHeader = (params = {}) => ({
  ...params,
  headers: {
    type: 'PORTAL'
  }
});

const getAllConversationThreads = (data: any, params = {}) => BaseApi.post('messaging/conversations', data, { params: getImpersonationParams(params), ...setMessagesHeader() });

const getConversationMessages = (conversationId: string, params: any) => BaseApi.get(`messaging/messages/${conversationId}`, { params: getImpersonationParams(params), ...setMessagesHeader() });

const sendMessage = (data: any, params = {}) => BaseApi.rawPost('messaging/create-message', data, setMessagesHeader(params));

const scanFile = (data: any, params = {}) => BaseApi.rawPost('virus-scan', data, setMessagesHeader({ ...params, baseURL: process.env.VUE_APP_VIRUS_SCAN_URL }));

const uploadAttachment = (url: string, file: any, contentType = '') => axios({
  method: 'put',
  url,
  data: file,
  headers: {
    'x-amz-storage-class': 'GLACIER_IR',
    ...(contentType ? { 'Content-Type': contentType } : {})
  }
});

const deleteAttachment = (data: any, params = {}) => BaseApi.deleteAttachments('messaging/attachment/delete', data, setMessagesHeader(params), false);

const messageCountSync = (data: any, params = {}) => BaseApi.rawPost('messaging/message-count-sync', data, setMessagesHeader({ params: getImpersonationParams(params) }));

export {
  getAllConversationThreads,
  getConversationMessages,
  sendMessage,
  scanFile,
  uploadAttachment,
  deleteAttachment,
  messageCountSync
};
